import { sourceHosts } from '../../lib/chatClient'

/**
 * A quiet row of host names under a researched answer, each a link out.
 * The page's title rides along as the link's accessible name, so a screen
 * reader hears what the page was and not only whose it is.
 */
export function Sources({ items }: { items: { url: string; title: string }[] }) {
  const hosts = sourceHosts(items)
  if (hosts.length === 0) return null
  return (
    <p className="chat-sources">
      <span className="chat-sources__label">Sources</span>
      {hosts.map(h => (
        <a
          key={h.url}
          href={h.url}
          target="_blank"
          rel="noopener"
          title={h.title || undefined}
          aria-label={h.title ? `${h.title} (${h.host})` : h.host}
        >
          {h.host}
        </a>
      ))}
    </p>
  )
}
